import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';

const CatalogSortingFilterBtn = function(props) {
  const { t } = useTranslation();

  const {
          button,
          onSetFilter,
          selectedValues,
        } = props;

  const isActive = !!selectedValues?.[button.query_key];
  // button.count: offers left if the tag is checked; a checked tag stays enabled to be unchecked
  const isDisabled = button.count === 0 && !isActive;
  const opacity  = isActive ? 'E6' : '99';
  const styles   = button.isColorEnabled
    ? {
      background: `${button.tagColor}${opacity}`,
      color:      button.tagTextColor,
      border:     `2px solid ${button.tagColor}`,
    }
    : void 0;

  return (
    <button
      style={{
        background: styles?.background,
        border:     styles?.border,
        color:      styles?.color,
      }}
      className={classNames('item', {
          active: isActive,
          disabled: isDisabled,
      })}
      // Not the `disabled` attribute on purpose: a disabled button swallows the mouse events, so the
      // drag-to-scroll of the tags row (mousedown on the wrapper) cannot start over it - at the end of the
      // row, where the disabled tags are, there would be nothing left to grab to scroll back.
      aria-disabled={isDisabled || undefined}
      tabIndex={isDisabled ? -1 : undefined}
      onClick={isDisabled ? undefined : onSetFilter}
    >{button.labelIsTranslationKey === false ? button.label : t(`client_${button.label}`)}</button>
  );
};

export default CatalogSortingFilterBtn;